const uid = () => Math.random().toString(36).slice(2, 10);
export const slug = (s) => (s || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "").slice(0, 40) || `field_${uid()}`;

// Every field needs its own key: answers are stored by key, so two fields sharing one
// mirror each other. The first field keeps its key; later duplicates get a numeric suffix.
export function withUniqueFieldKeys(sections) {
  const used = new Set();
  return (sections || []).map((s) => ({
    ...s,
    fields: (s.fields || []).map((f) => {
      const base = f.key || slug(f.label) || f.id;
      let key = base, n = 2;
      while (used.has(key)) key = `${base}_${n++}`;
      used.add(key);
      return { ...f, key };
    }),
  }));
}
